module.exports = __webpack_public_path__ + "static/media/dashboard_has_logged_in_icon.160b723d.png";